import { useNavigate } from 'react-router-dom';
import './yar.css';

/**
 * Demo-tenant call to action, pinned above everything (topbar included, not
 * closable). It is the former floating «می‌خواهم ERP خودم رو بسازم» button as a
 * full-width banner with a fast-moving background; motion stops under
 * `prefers-reduced-motion`.
 */
export function DemoBanner() {
  const navigate = useNavigate();
  return (
    <button type="button" className="demo-banner" onClick={() => navigate('/start/trial')}>
      <span className="demo-banner__spark" aria-hidden="true">
        ✦
      </span>
      <span className="demo-banner__text">می‌خواهم ERP خودم رو بسازم</span>
      <span className="demo-banner__arrow" aria-hidden="true">
        ‹
      </span>
    </button>
  );
}
